const URLS_EXTERNAL = {
  FACEBOOK_COMMUNITY_URL:
    'https://www.facebook.com/groups/cryptocuriouscommunity',
}

export default URLS_EXTERNAL
